import { useAuthContext } from './agencyAuthHook'
import { getAllBookings } from '../redux/reducers/bookingsSlice'
import { useDispatch } from 'react-redux';

export default function BookingHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getBookings=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/bookings/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllBookings(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getBookings}
}
